import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ConfirmationModal, Typography } from 'seagull';
import { OpenTab } from 'seagull/icons';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { openInNewTabProps, routes } from '~/constants';
import { useLocaleKeys } from '~/i18n';
import styles from './CopyAPIKeyModal.module.scss';
import { getIntegrationHeader, getIntegrationSteps } from './integrationSteps';
export default function CopyAPIKeyModal(param) {
    let { dismissModal, slug, title, integrationUrl } = param;
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { t: common } = useLocaleKeys('common');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'copy_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'copy_a_p_i_key_cancel'
            }
        },
        title: sharedTexts.integrateWithTitle({
            title
        }),
        width: "760px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.modalContainer,
            children: [
                getIntegrationHeader(slug),
                /*#__PURE__*/ _jsx(Typography, {
                    children: sharedTexts.toIntegrateFollowSteps({
                        title
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.stepsContainer,
                    children: [
                        /*#__PURE__*/ _jsxs(Typography, {
                            children: [
                                "1. Go to the",
                                ' ',
                                /*#__PURE__*/ _jsx(ExternalLinkButton, {
                                    href: routes.anchorApiKeys,
                                    underline: "none",
                                    openInNewTab: true,
                                    bi: {
                                        name: 'anchor_api_keys_link',
                                        data: {
                                            slug
                                        }
                                    },
                                    children: "Anchor API Keys"
                                }),
                                ' ',
                                "page and generate a new API key for ",
                                title,
                                "."
                            ]
                        }),
                        getIntegrationSteps(slug)
                    ]
                }),
                /*#__PURE__*/ _jsxs(Button, _object_spread_props(_object_spread({
                    bi: {
                        name: 'go_to_integration',
                        data: {
                            slug
                        }
                    },
                    skin: "primaryOutline",
                    testId: "go-to-".concat(slug),
                    as: "a",
                    suffixIcon: /*#__PURE__*/ _jsx(OpenTab, {}),
                    href: integrationUrl
                }, openInNewTabProps), {
                    className: styles.goToContainer,
                    children: [
                        "Go to ",
                        title
                    ]
                }))
            ]
        }),
        primaryButtonLabel: common.buttons.close(),
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        testId: "integrate-with-".concat(slug, "-modal")
    });
}
